import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

const CustomDataTable = ({
  data,
  loading,
  selectionMode,
  selectedItems,
  onSelectionChange,
  valueField,
  sortField,
  sortOrder,
  onSort,
  rowClickHandler,
  emptyMessage,
  columns,
}) => {
  return (
    <DataTable
      lazy={true}
      loading={loading}
      selectionMode={selectionMode}
      selection={selectedItems}
      onSelectionChange={onSelectionChange}
      value={Array.isArray(data) ? data : []}
      sortField={sortField}
      sortOrder={sortOrder}
      onSort={onSort}
      className="p-datatable-sm"
      rowHover={true}
      responsiveLayout="stack"
      emptyMessage={emptyMessage}
      onRowClick={rowClickHandler}
    >
      {columns.map((column) => (
        <Column
          key={column.field}
          field={column.field}          
          header={column.header}
          body={column.body}
        />
      ))}
    </DataTable>
  );
};

export default CustomDataTable;
